<template>
  <div>
		<customerIntro/>
		<SxnCta/>
  </div>
</template>

<script>
import { bus } from '../../../main'
import customerIntro from './customerIntro';
import SxnCta from '../../commons/SxnCta';
export default {
  name: 'customer',
  components: {
    customerIntro,
    SxnCta
  },
  data: () => ({
    
  }),
  mounted() {
		console.log(this.$route);
		bus.$emit('update-route', this.$route);
  }
};
</script>
